export default function Footer() {
  const anchors = [
    { id: "overview", label: "事件一览" },
    { id: "graph", label: "人物图谱" },
    { id: "persons", label: "核心人物" },
    { id: "relations", label: "关系解析" },
    { id: "timeline", label: "时间脉络" },
    { id: "faq", label: "常见问题" },
  ];

  return (
    <footer className="bg-[#f1e6d6]">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6">
        <div className="flex flex-col items-start justify-between gap-8 sm:flex-row sm:items-center">
          <div>
            <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-[#b4372a] text-white">
                <i className="ri-node-tree text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-serif-sc text-lg font-bold text-[#2a2320]">吃瓜门图谱</span>
            </a>
            <p className="mt-3 max-w-xs text-sm leading-relaxed text-[#7a6f66]">
              以关系图谱梳理吃瓜门谁是谁，帮助你快速理解核心人物、相关人物与关联方之间的整体结构。
            </p>
          </div>

          <nav className="flex flex-wrap gap-x-6 gap-y-2" aria-label="页脚导航">
            {anchors.map((a) => (
              <a
                key={a.id}
                href={`#${a.id}`}
                className="text-sm whitespace-nowrap text-[#5a5049] transition hover:text-[#b4372a]"
              >
                {a.label}
              </a>
            ))}
          </nav>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-[#e2cfb6] pt-6 text-xs text-[#8a7c6c] sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} 吃瓜门图谱 · 仅供信息关系梳理参考</p>
          <p className="flex items-center gap-4">
            <span className="inline-flex items-center gap-1">
              <i className="ri-mail-line" aria-hidden="true"></i> hello@chiguamen.example
            </span>
            <span className="inline-flex items-center gap-1">
              <i className="ri-question-line" aria-hidden="true"></i> 内容以公开信源为准，真伪请自行核实
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
}